export class LocalizedString {
    valueEn: string;
    valueFi: string;
    valueSv: string;
}
